import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import CustomerValidations from 'scaleflow/validators/customer';

export interface QuickAddsCustomerSignature {
  // The arguments accepted by the component
  Args: {
    isOpen?: boolean;
    handleFormDismiss?: () => void;
    onItemSaved?: (customer: any) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class QuickAddsCustomerComponent extends Component<QuickAddsCustomerSignature> {
  @service declare store: any;
  @service declare router: any;

  customer = {
    name: '',
  };
  customerValidations = CustomerValidations;

  @action
  async onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const customer = this.store.createRecord('customer', {
        name: changeset.name,
      });
      await customer.save();
      this.args?.onItemSaved?.(customer);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }
}
